import type { TariffsSearchFiltersFormValues, TariffsSearchParams } from '../../models';

type FormOption<T extends string | number> = { id: T; label: string };

export const toFormOption = <T extends string | number>(
  id: T | null | undefined,
  label?: string,
): FormOption<T> | null => {
  if (id === null || id === undefined) {
    return null;
  }

  return { id, label: label || '' };
};

export const toParamNumber = (value: string | null | undefined): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  return Number(value);
};

// Form objects -> URL params
export const normalizeTariffFiltersUpdate = (filters: TariffsSearchFiltersFormValues): TariffsSearchParams => ({
  branchKey: filters.branchKey?.id ?? undefined,
  cargoType: filters.cargoType?.id ?? undefined,
  carrierKey: filters.carrierKey?.id ?? undefined,
  currencyCode: filters.currencyCode?.id ?? undefined,
  customerLaneId: filters.customerLaneId ?? undefined,
  effectiveDate: filters.effectiveDate,
  expirationDate: filters.expirationDate,
  laneKey: filters.laneKey?.id ?? undefined,
  linerType: filters.linerType?.id ?? undefined,
  packingCode: filters.packingCode?.id ?? undefined,
  pricingType: filters.pricingType?.id ?? undefined,
  serviceKey: filters.serviceKey?.id ?? undefined,
  tariffKey: toParamNumber(filters.tariffKey),
  tariffName: filters.tariffName ?? undefined,
  tariffType: filters.tariffType?.id ?? undefined,
  trailerKey: filters.trailerKey?.id ?? undefined,
});
